import {useState} from 'react';
import {useAppDispatch} from '../../../store/app-hooks';
import useConfirm from '../../../hooks/useConfirm';
import useProgramWithUsersFromParams from '../../../hooks/useProgramWithUsersFromParams';
import {useCollectorData} from '../../../store/user/userSlice';
import {useNotification} from '../../../store/notification/NotificationContext';
import {clearError, removeUserFromProgram} from '../../../store/programs/programsSlice';

import {Button} from '../../../components/UI/Button';
import {RemovableChip} from '../../../components/UI/Chips/RemovableChip';
import UserModal from '../../../components/shared/UserModal';
import UserSelectionModal from '../../../components/shared/UserSelectionModal/UserSelectionModal';

import {FIELD_LABELS} from '../../../constants';
import s from './index.module.scss';

const {SUCCESSFUL_DELETION, FAIL_DELETION, DELETE_OBJECT, MODAL_CONFIRMATION} = FIELD_LABELS;

export const ProgramParticipantsContent = () => {
    const [program] = useProgramWithUsersFromParams();
    const [collectors] = useCollectorData();
    const [openUserModal, setOpenUserModal] = useState(false);
    const [openUserSelection, setOpenUserSelection] = useState(false);

    const dispatch = useAppDispatch();
    const {confirm} = useConfirm();
    const {addNotification} = useNotification();

    const handleCloseNewUserModal = () => {
        setOpenUserModal(false);
    };

    const handleCloseUserSelectionModal = () => {
        dispatch(clearError());
        setOpenUserSelection(false);
    };

    const onRemoveUserFmProgram = async (userId: string) => {
        const result = await confirm(MODAL_CONFIRMATION, DELETE_OBJECT);

        if (result && program) {
            dispatch(removeUserFromProgram({programId: program.id, userId}))
                .unwrap()
                .then(() => {
                    addNotification(SUCCESSFUL_DELETION, 'success');
                })
                .catch(() => addNotification(FAIL_DELETION, 'error'));
        }
    };

    return (
        <>
            <div className={s.content}>
                <div className={s.uncategorised}>
                    <div className={s.header}>
                        <div className={`${s.title} ${s.group}`}>Participants</div>

                        <Button
                            label="Add New"
                            variant="Tertiary"
                            onClick={() => setOpenUserModal(true)}
                        />
                        <Button
                            label="Select from List"
                            onClick={() => setOpenUserSelection(true)}
                        />
                    </div>
                    <div className={s.list}>
                        {program && program.users.length > 0 ? (
                            program?.users.map((user) => (
                                <RemovableChip
                                    label={`${user.first_name} ${user.last_name}`}
                                    key={user.id}
                                    onClick={() => onRemoveUserFmProgram(user.id)}
                                />
                            ))
                        ) : (
                            <i>Add users to the program</i>
                        )}
                    </div>
                </div>
            </div>
            {openUserModal && program && (
                <UserModal
                    programId={program.id}
                    closeModal={() => handleCloseNewUserModal()}
                />
            )}
            {openUserSelection && program && (
                <UserSelectionModal
                    users={collectors}
                    program={program}
                    onClose={() => handleCloseUserSelectionModal()}
                />
            )}
        </>
    );
};
